import React from 'react';
import RippleButton from '../../common/RippleButton';

interface QuickActionsProps {
  className?: string;
  onNewTransaction?: () => void;
  onViewReports?: () => void;
}

const QuickActions: React.FC<QuickActionsProps> = ({
  className = '',
  onNewTransaction,
  onViewReports
}) => {
  const handleNewTransaction = () => {
    if (onNewTransaction) {
      onNewTransaction();
    } else {
      // Default behavior - show alert for demo
      alert('New Transaction feature - Interactive prototype');
    }
  };

  const handleViewReports = () => {
    if (onViewReports) {
      onViewReports();
    } else {
      // Default behavior - show alert for demo
      alert('View Reports feature - Interactive prototype');
    }
  };

  return (
    <div className={`quick-actions ${className}`}>
      <h2 className="section-title">
        <svg className="section-icon" viewBox="0 0 20 20" fill="currentColor">
          <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" />
        </svg>
        Quick Actions
      </h2>
      
      <div className="quick-actions-buttons">
        <RippleButton
          className="btn-new-transaction"
          onClick={handleNewTransaction}
          variant="primary"
        >
          New Transaction
        </RippleButton>
        
        <RippleButton
          className="btn-view-reports"
          onClick={handleViewReports}
          variant="secondary"
        >
          View Reports
        </RippleButton>
      </div>
    </div>
  );
};

export default QuickActions;